@if (failedAt()) {
  <span class="error" tabindex="0" [matTooltip]="description()" [attr.aria-label]="description()">
    <svg lucideTriangleAlert></svg>
    Envoi échoué le {{ failedAt() | date: 'dd/MM/yyyy' }}
  </span>
}
